import { IPatient } from '~/services/api/patients/types';
import { IPatientFormValues } from '../types';
import { getPhysicianInitialValues } from '../PhysiciansSection/form';

const getInitialValues = (patient: IPatient): IPatientFormValues => {
  const dateOfBirth = patient.dateOfBirth ? new Date(patient.dateOfBirth) : null;

  return {
    ...patient,
    homePhone: patient.homePhone ?? '',
    cellPhone: patient.cellPhone ?? '',
    workPhone: patient.workPhone ?? '',
    emergencyContactPhone: patient.emergencyContactPhone ?? '',
    dateOfBirth: dateOfBirth
      ? new Date(
          dateOfBirth.getUTCFullYear(),
          dateOfBirth.getUTCMonth(),
          dateOfBirth.getUTCDate(),
        ).toISOString()
      : null,
    healthCareManagerIds: patient.healthCareManagers.map(item => item.id),
    isHomeHealthCare: String(Number(patient.isHomeHealthCare)),
    shippingAddressSameAsHome: String(Number(patient.shippingAddressSameAsHome)),
    attendingPhysicianId: patient.attendingPhysicianId,
    secondaryPhysicians: patient.secondaryPhysicians.map(getPhysicianInitialValues),
  };
};

export default getInitialValues;
